import { REGEX } from "../constants/regex";
import { STRING } from "../constants/string";

export class Base64 {
  static encode(data: Blob): Promise<string> {
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onload = () => {
        const data: string = reader.result as string || STRING.EMPTY;
        resolve(data.replace(REGEX.STRING.BASE64_DESCRIPTION, STRING.EMPTY));
      };

      reader.onerror = reject;
      reader.readAsDataURL(data);
    });
  }

  static decode(string: string, encoding: string): string {
    const bytesArray = new Uint8Array(atob(string).split(STRING.EMPTY).map(c => c.charCodeAt(0)));
    return new TextDecoder(encoding).decode(bytesArray);
  }
}
